import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'
import { useMemo } from 'react'
import { isPhaseCompleted } from 'Cube/domain/postActionStages/queries/availableFeatures/phases/isPhaseCompleted'

export const usePhaseDetails = (props: { phaseId: string }) => {
  const cubeContext = useCubeContext()

  const resolvedPhase = cubeContext.queries.resolvedPhases[props.phaseId]
  const availableFeaturesForPhase =
    cubeContext.queries.availableFeatures.phases[resolvedPhase.id].phase
  const isOnlyPhase =
    Object.values(cubeContext.queries.rawData.data.phases).length === 1
  const isFirstPhase =
    cubeContext.queries.orderedPhases[0]?.id === props.phaseId

  const isLastPhase = useMemo(() => {
    if (isOnlyPhase) {
      return true
    }

    const sortedPhases = cubeContext.queries.orderedPhases

    return sortedPhases[sortedPhases.length - 1].id === props.phaseId
  }, [cubeContext.queries.orderedPhases, isOnlyPhase, props.phaseId])

  const insertBeforeDisabled =
    !availableFeaturesForPhase.insert.before.available.visible
  const insertAfterDisabled =
    !availableFeaturesForPhase.insert.after.available.visible

  const previousPhaseEndDate = useMemo(() => {
    const currentPhaseIndex = cubeContext.queries.orderedPhases.findIndex(
      op => op.id === props.phaseId
    )
    if (currentPhaseIndex < 1) {
      return
    }

    const previousPhase =
      cubeContext.queries.orderedPhases[currentPhaseIndex - 1]

    return previousPhase.dates.absolute.end
  }, [cubeContext])

  const phaseComplete = useMemo(() => {
    const persistedPhaseEndDate =
      cubeContext.queries.initialQueries.resolvedPhases[props.phaseId]?.dates
        .absolute.end

    return isPhaseCompleted({
      scheduleStatus: cubeContext.queries.rawData.data.common.status,
      persistedPhaseEndDate,
      today: new Date(),
      isBeforeAmendmentEffectiveFrom:
        resolvedPhase.isBeforeAmendmentEffectiveFrom
    })
  }, [
    cubeContext.queries.initialQueries.resolvedPhases,
    cubeContext.queries.rawData.data.common.status,
    resolvedPhase.isBeforeAmendmentEffectiveFrom,
    props.phaseId
  ])

  return {
    resolvedPhase,
    availableFeaturesForPhase,
    isOnlyPhase,
    isFirstPhase,
    isLastPhase,
    previousPhaseEndDate,
    phaseComplete,
    insertBeforeDisabled,
    insertAfterDisabled
  }
}
